const PRODEP_GRADE = [
  { _id: 1, label: "Licenciada", shortLabel: "Licda.", art: "la" },
  { _id: 2, label: "Licenciado", shortLabel: "Licdo.", art: "el" },
  { _id: 3, label: "Maestra", shortLabel: "Mtra.", art: "la" },
  { _id: 4, label: "Maestro", shortLabel: "Mtro.", art: "el" },
  { _id: 5, label: "Doctora", shortLabel: "Dra.", art: "la" },
  { _id: 6, label: "Doctor", shortLabel: "Dr.", art: "el" },
];

const PRODEP_PROGRAMA = [
  { _id: 1, label: "Administración" },
  { _id: 2, label: "Contaduría" },
  { _id: 3, label: "Derecho" },
  { _id: 4, label: "Pedagogía" },
  { _id: 5, label: "Sociologia" },
];

const PRODEP_REGION = [
  { _id: 1, label: "Coatzacoalcos" },
  { _id: 2, label: "Orizaba" },
  { _id: 3, label: "Poza Rica" },
  { _id: 4, label: "Veracruz" },
  { _id: 5, label: "Xalapa" },
];

const PRODEP_PROCEDURE = [
  { _id: 1, label: "Jurado" },
  { _id: 2, label: "Director" },
  { _id: 3, label: "Directora" },
];

const PRODEP_TITLE = [
  { _id: 1, label: "Tesis" },
  { _id: 2, label: "Tesina" },
  { _id: 3, label: "Monografía" },
  { _id: 4, label: "Reporte" },
];

export {
  PRODEP_GRADE,
  PRODEP_PROGRAMA,
  PRODEP_REGION,
  PRODEP_PROCEDURE,
  PRODEP_TITLE,
};
